import "./SnapWidgetPrivacyPolicy.css";

const updatedAt = "July 11, 2026";

const sections = [
  {
    title: "1. What Information We Collect",
    body: [
      "We collect personal information that you voluntarily provide when you contact us, request support, respond to feedback prompts, or otherwise interact with Privacy Screen Guard. This may include your email address and the contents of messages you send to us.",
      "If you make a purchase, payment and transaction information is processed by Google Play or the applicable payment provider. BlackDoor does not store full debit card, credit card, UPI, wallet, or bank account details.",
      "We do not intentionally collect or process sensitive personal information except where you choose to enable on-device smart privacy features described below."
    ]
  },
  {
    title: "2. Application and Device Data",
    body: [
      "Privacy Screen Guard may request access to device features that are necessary for app functionality, such as overlay/display permissions, notification permissions, or other settings you choose to enable.",
      "We may automatically collect device and usage information such as device model, manufacturer, operating system, app version, device identifiers, IP address, crash logs, diagnostics, feature usage, language preferences, and approximate location derived from device or network data.",
      "This information is primarily used to operate the app, troubleshoot issues, maintain security, understand usage trends, and improve product quality."
    ]
  },
  {
    title: "3. Camera, Face Detection, and Smart Privacy Features",
    body: [
      "If you enable Peek-a-Boo or Look Away, Privacy Screen Guard uses your device's front camera to analyze camera frames on your device for privacy-protection signals, such as whether more than one face is visible, whether the registered viewer is present, or whether the registered viewer appears to look away from the screen.",
      "These features use on-device face detection and on-device AI/ML face analysis. Camera frames are not sent to BlackDoor servers for these features, and we do not use these features to identify people by name.",
      "Look Away may ask you to register your face on the device. During registration, the app creates a local face embedding or similar mathematical template so the app can recognize the registered viewer on that device. The app stores that registration data locally on the device, and you can update it in the app or remove it by clearing app data or uninstalling the app.",
      "We may record non-image feature events, such as whether smart privacy features were enabled or disabled, to analytics providers for diagnostics and product improvement. We do not intentionally send face images, video, face embeddings, or camera frames to analytics providers."
    ]
  },
  {
    title: "4. Google API Data",
    body: [
      "Our use of information received from Google APIs will adhere to the Google API Services User Data Policy, including the Limited Use requirements."
    ]
  },
  {
    title: "5. How We Process Information",
    body: [
      "We process information to provide, improve, and administer Privacy Screen Guard, respond to support requests, request feedback, protect the app, prevent fraud, identify usage trends, comply with legal obligations, and protect vital interests where necessary.",
      "Where required by law, we process information with your consent. You may withdraw consent at any time, subject to applicable law and the continued functionality of permissions you choose to disable."
    ]
  },
  {
    title: "6. Legal Bases",
    body: [
      "Depending on where you live, we may rely on consent, performance of a contract, legitimate interests, legal obligations, or vital interests as the legal basis for processing your personal information.",
      "For users in the EEA, UK, Switzerland, Canada, Australia, New Zealand, South Africa, and certain U.S. states, additional regional rights may apply."
    ]
  },
  {
    title: "7. When We Share Information",
    body: [
      "We may share information with service providers that help us operate Privacy Screen Guard, including hosting, analytics, diagnostics, payment processing, customer support, fraud prevention, and app store services.",
      "We may also share or transfer information in connection with a merger, sale of company assets, financing, acquisition, legal request, enforcement of our terms, protection of rights and safety, or compliance with applicable law."
    ]
  },
  {
    title: "8. Cookies, Analytics, and Tracking",
    body: [
      "We may use cookies, pixels, web beacons, SDKs, analytics tools, and similar technologies in our websites and services.",
      "These technologies may help maintain security, prevent crashes, fix bugs, remember preferences, measure usage, support analytics, and support advertising where permitted by law.",
      "We may use analytics tools such as Firebase Analytics, PostHog, Google Analytics, or similar tools to understand usage. You can learn about Google's privacy practices at the Google Privacy & Terms page."
    ]
  },
  {
    title: "9. Payments",
    body: [
      "Privacy Screen Guard may offer paid access, paid features, or other one-time purchases. Payments are processed through Google Play or another payment provider shown at checkout.",
      "Payment providers may collect billing details, tax information, fraud signals, and transaction records under their own privacy notices and terms. We receive limited purchase status information needed to unlock paid features, provide support, prevent abuse, and keep financial records where required by law.",
      "For Google Play purchases, our systems may receive and store limited purchase verification data such as product ID, internal product ID, package name, purchase status, purchase token, acknowledgement status, verification result, restore status, and an app-generated user identifier. We use this information to verify the correct product was purchased, unlock or restore paid features, prevent fraud, troubleshoot billing issues, and handle refunds or chargebacks.",
      "We do not receive or store your full payment method details, and Google Play does not provide us with the Play Store account email used for the purchase unless you separately provide an email to us for support.",
      "Payments for Privacy Screen Guard are one-time and non-refundable except where a refund is required by applicable law or mandatory payment provider policy."
    ]
  },
  {
    title: "10. How Long We Keep Information",
    body: [
      "We keep personal information for as long as necessary for the purposes described in this policy, unless a longer retention period is required or permitted by law.",
      "When we no longer have an ongoing legitimate need to process personal information, we delete or anonymize it. If deletion is not immediately possible, we securely store it and isolate it from further processing until deletion is possible."
    ]
  },
  {
    title: "11. How We Keep Information Safe",
    body: [
      "We use reasonable technical and organizational safeguards designed to protect personal information.",
      "No electronic transmission or storage technology can be guaranteed to be fully secure, so you should access Privacy Screen Guard only in a secure environment."
    ]
  },
  {
    title: "12. Your Privacy Rights",
    body: [
      "Depending on where you live, you may have rights to access, correct, delete, restrict, object to, or receive a copy of your personal information.",
      "You may also have rights to withdraw consent, opt out of targeted advertising, sale or sharing of personal information, and certain profiling activities.",
      "We will review and respond to privacy requests in accordance with applicable privacy laws."
    ]
  },
  {
    title: "13. United States State Privacy Rights",
    body: [
      "Residents of certain U.S. states, including California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, and Virginia, may have additional privacy rights.",
      "These rights may include knowing whether we process personal information, accessing it, correcting inaccuracies, requesting deletion, obtaining a portable copy, non-discrimination for exercising rights, and opting out of targeted advertising, sale, sharing, or profiling where applicable.",
      "We do not sell personal information and do not knowingly sell or share personal information of children."
    ]
  },
  {
    title: "14. Do-Not-Track",
    body: [
      "Some browsers and mobile systems include Do-Not-Track settings. Because no uniform technical standard has been finalized, we do not currently respond to Do-Not-Track browser signals."
    ]
  },
  {
    title: "15. Children",
    body: [
      "Privacy Screen Guard is not intended for children under 18 years of age, or the equivalent minimum age required by law in your jurisdiction.",
      "We do not knowingly collect, solicit, sell, or market personal information from children. If you believe we collected information from a child, contact us and we will take reasonable steps to delete it."
    ]
  },
  {
    title: "16. Updates",
    body: [
      "We may update this Privacy Policy from time to time. The updated version will be identified by the updated date above.",
      "If we make material changes, we may notify you through the app, website, app store listing, or another appropriate method."
    ]
  },
  {
    title: "17. Contact Us",
    body: [
      "If you have questions, comments, or privacy requests, contact us at support@blackdoorapps.com or by post at BlackDoor, Kalyannagar, North 24 Parganas, Kolkata, West Bengal 700112, India."
    ]
  }
];

function PrivacyScreenGuardPrivacyPolicy() {
  return (
    <main className="snap-policy-page">
      <section className="snap-policy-hero">
        <a className="snap-policy-brand" href="/" aria-label="BlackDoor home">
          BlackDoor
        </a>
        <p className="snap-policy-kicker">Privacy Screen Guard</p>
        <h1>Privacy Policy</h1>
        <p className="snap-policy-updated">Last updated {updatedAt}</p>
        <p className="snap-policy-summary">
          This Privacy Policy explains how BlackDoor collects, uses, shares, and protects information when you use Privacy Screen Guard and related services.
        </p>
      </section>

      <section className="snap-policy-content" aria-label="Privacy policy content">
        <div className="snap-policy-card snap-policy-intro">
          <h2>Summary</h2>
          <p>
            We process information to operate Privacy Screen Guard, improve product quality, protect users, process one-time purchases, respond to support requests, and comply with law. If you do not agree with this policy, please do not use Privacy Screen Guard.
          </p>
        </div>

        {sections.map((section) => (
          <article className="snap-policy-card" key={section.title}>
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </article>
        ))}

        <div className="snap-policy-card snap-policy-actions">
          <h2>Review, Update, or Delete Your Data</h2>
          <p>
            To request access, correction, deletion, or another privacy action, email{" "}
            <a href="mailto:support@blackdoorapps.com">support@blackdoorapps.com</a>.
          </p>
          <p>
            You may also submit a data subject access request at{" "}
            <a href="https://forms.gle/AL7SieXmDvj9wjor7" target="_blank" rel="noreferrer">
              https://forms.gle/AL7SieXmDvj9wjor7
            </a>.
          </p>
          <p>
            For payment privacy information, review Google's payment privacy notice at{" "}
            <a href="https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en-GB" target="_blank" rel="noreferrer">
              Google Payments Privacy Notice
            </a>.
          </p>
        </div>
      </section>
    </main>
  );
}

export default PrivacyScreenGuardPrivacyPolicy;
